import Box from '@/common/components/Box'
import ResumeItem from '@/common/components/ResumeItem'
import { formatCurrency, formatDecimalUnit, formatDecimalWithGroupedUnit } from '@/common/utils/formatters'
import { CompanyContractConsumptionControlledBy } from '@/features/company/types/contract.type'
import { DeleteEntryProductCategoryModal } from '@/features/governmentAllocations/pages/Update/components/DeleteEntryProductCategoryModal'
import { EntryGovernmentAllocationDetailsQuantity } from '@/features/governmentAllocations/pages/Update/components/EntryGovernmentAllocationDetailsQuantity'
import { UpdateEntryProductCategoryModal } from '@/features/governmentAllocations/pages/Update/components/UpdateEntryProductCategoryModal'
import { GovernmentAllocationEntryProductCategory } from '@/features/governmentAllocations/types/governmentAllocationEntry.type'
import { BoxesIcon, FileBoxIcon } from 'lucide-react'

interface EntryGovernmentAllocationDetailsProps {
  companyBranchId?: string
  governmentAllocationId: string
  entryProductCategories: GovernmentAllocationEntryProductCategory[]
  disabled: boolean
  hideButtons?: boolean
  controlledBy?: CompanyContractConsumptionControlledBy
}

export const EntryGovernmentAllocationDetails = ({
  companyBranchId,
  governmentAllocationId,
  entryProductCategories,
  disabled,
  hideButtons,
  controlledBy = CompanyContractConsumptionControlledBy.Currency,
}: EntryGovernmentAllocationDetailsProps) => {
  const isQuantity = controlledBy === CompanyContractConsumptionControlledBy.Quantity

  if (controlledBy === CompanyContractConsumptionControlledBy.Quantity) {
    return (
      <EntryGovernmentAllocationDetailsQuantity
        companyBranchId={companyBranchId}
        governmentAllocationId={governmentAllocationId}
        entryProductCategories={entryProductCategories}
        disabled={disabled}
        hideButtons={hideButtons}
      />
    )
  }

  return (
    <div className="flex flex-col gap-4">
      {entryProductCategories.map((entryProductCategory) => (
        <Box className="flex flex-col gap-3 p-4" key={entryProductCategory.id}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-x-6">
              <div className="flex items-center gap-x-2 text-white-800">
                <BoxesIcon strokeWidth={1} />

                <p>{entryProductCategory.product_category.display_name}</p>
              </div>

              <ResumeItem
                label={isQuantity ? "Quantidade limite" : "Valor limite"}
                value={isQuantity
                  ? formatDecimalWithGroupedUnit(
                    Number(entryProductCategory.total_quantity),
                    entryProductCategory.entry_products,
                    (p) => p.product.unit_for_quantity,
                  )
                  : formatCurrency(Number(entryProductCategory.total_value))
                }
                className="text-center"
              />
            </div>

            {!hideButtons && (
              <div className="flex gap-x-8">
                <DeleteEntryProductCategoryModal
                  governmentAllocationId={governmentAllocationId}
                  entryProductCategoryId={entryProductCategory.id}
                  disabled={disabled}
                />

                <UpdateEntryProductCategoryModal
                  companyBranchId={companyBranchId}
                  governmentAllocationId={governmentAllocationId}
                  entryProductCategory={entryProductCategory}
                />
              </div>
            )}
          </div>

          {entryProductCategory.entry_products.map((entryProduct) => (
            <Box className="py-3 px-3" key={entryProduct.id}>
              <div className="flex items-center justify-between border-s border-blue-800 px-3">
                <div className="flex items-center gap-x-2">
                  <FileBoxIcon strokeWidth={1.5} />

                  <p>{entryProduct.product.display_name}</p>
                </div>

                <ResumeItem
                  label={isQuantity ? "Quantidade limite" : "Valor limite"}
                  value={isQuantity
                    ? formatDecimalUnit(Number(entryProduct.total_quantity), entryProduct.product.unit_for_quantity)
                    : formatCurrency(Number(entryProduct.total_value))
                  }
                  className="text-center"
                />
              </div>
            </Box>
          ))}
        </Box>
      ))}
    </div>
  )
}
